import * as React from "react";
const SvgPaint = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.768 1.269a1.035 1.035 0 0 1 1.463 0l9.869 9.868c.185.186.37.369.512.536.15.176.312.402.409.698.132.409.132.85 0 1.258a2.1 2.1 0 0 1-.409.698c-.142.167-.326.35-.512.536l-5.474 5.475c-.582.582-1.062 1.063-1.484 1.422-.432.366-.872.664-1.396.835a4.04 4.04 0 0 1-2.493 0c-.524-.17-.964-.469-1.396-.835-.422-.359-.901-.84-1.483-1.422l-3.212-3.212c-.582-.582-1.063-1.062-1.422-1.484-.366-.432-.665-.87-.836-1.395a4.04 4.04 0 0 1 0-2.494c.17-.524.47-.963.836-1.395.359-.422.84-.902 1.422-1.484L10.036 3l-.268-.269a1.035 1.035 0 0 1 0-1.462M4.109 14.035q.084.118.21.267c.29.343.7.754 1.307 1.36l3.21 3.212c.607.606 1.018 1.017 1.361 1.308.334.283.535.392.696.444.394.128.819.128 1.213 0 .161-.052.362-.161.696-.444.343-.291.754-.702 1.36-1.308l4.839-4.839zm1.517-3.697c-.606.606-1.017 1.017-1.308 1.36a4 4 0 0 0-.209.267h14.892l-7.502-7.502z"
}));
export default SvgPaint;
//# sourceMappingURL=Paint.js.map